<template>
  <div class="flex items-center gap-3">
    <!-- Rejected/Dismissed Status -->
    <div
      v-if="isRejected"
      class="text-gray-500 text-sm flex items-center gap-1 border-[1px] border-gray-400 rounded-md px-3 py-0.5"
    >
      <CircleX class="w-4 h-5" />
      Rejected Report
    </div>

    <!-- Pending/Under Review Status -->
    <div
      v-if="isPending"
      class="text-yellow-600 text-sm flex items-center gap-1 border-[1px] border-yellow-400 rounded-md px-3 py-0.5"
    >
      <MessageSquareWarning class="w-4 h-5" />
      Report
    </div>

    <!-- Strike Status -->
    <div
      v-if="isActiveStrike"
      class="text-red-600 text-sm flex items-center gap-1 border-[1px] border-red-400 rounded-md px-3 py-0.5"
    >
      <CircleX class="w-4 h-5" />
      Warning Issued
      <span v-if="report.resulted_in_suspension">- Resulted in Suspension</span>
    </div>

    <!-- Revoked Strike Status -->
    <div
      v-if="isRevokedStrike"
      class="text-lime-600 text-sm flex items-center gap-1 border-[1px] border-lime-400 rounded-md px-3 py-0.5"
    >
      <CircleCheck class="w-4 h-5" />
      Revoked Warning
    </div>

    <!-- Report Reason -->
    <h3 class="text-md text-gray-600 flex-1">{{ report.reason_display }}</h3>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CircleX, CircleCheck, MessageSquareWarning } from 'lucide-vue-next'
import type { Report, FellowReport } from '@/types/reports'

const props = defineProps<{
  report: Report | FellowReport
}>()

const isRejected = computed(() => ['REJECTED', 'DISMISSED'].includes(props.report.status))
const isPending = computed(() => ['PENDING', 'UNDER_REVIEW'].includes(props.report.status))
const isActiveStrike = computed(() => props.report.is_strike && !props.report.is_revoked_strike)
const isRevokedStrike = computed(() => props.report.is_revoked_strike)
</script> 